"use client";

import { useRef } from "react";
import {
  AriaListBoxOptions,
  useListBox,
  useOption,
} from "react-aria";
import { useSelectState } from "react-stately";
import { csx } from "../utils";

import "./ListBox.css";

interface ListBoxProps extends AriaListBoxOptions<unknown> {
  /**
   * State management object from react-stately
   */
  state: ReturnType<typeof useSelectState>;
}

/**
 * A list box component that renders a list of options
 * @interface ListBoxProps
 */
const ListBox = (props: ListBoxProps) => {
  let localRef = useRef<HTMLUListElement>(null);
  let { state } = props;
  let { listBoxProps } = useListBox(props, state, localRef);

  return (
    <ul
      {...listBoxProps}
      ref={localRef}
      data-testid="listbox"
      className="proton-ListBox"
    >
      {[...state.collection].map((item) => {
        return <ListBoxItem key={item.key} item={item} state={state} />;
      })}
    </ul>
  );
};

export function ListBoxItem({ item, state }) {
  let ref = useRef<HTMLLIElement>(null);
  let { optionProps, isSelected, isFocused, isDisabled } = useOption(
    { key: item.key },
    state,
    ref
  );

  return (
    <li
      {...optionProps}
      className={csx(
        "proton-ListBox__item",
        isFocused && "proton-ListBox__item--focused",
        isSelected && "proton-ListBox__item--selected",
        isDisabled && "proton-ListBox__item--disabled"
      )}
      ref={ref}
    >
      {item.rendered}
    </li>
  );
}

export default ListBox;
